export const socialsData = {
    github: 'https://github.com/umeshkumarmishra',
    facebook: 'https://www.facebook.com/umishra841@gmail.com',
    linkedIn: 'https://www.linkedin.com/in/umeshkumarmishra',
    instagram: 'https://www.instagram.com/mishraumesh98',
    stackOverflow: 'https://stackoverflow.com/users/',
    twitter: 'https://twitter.com/umishra841',
    // codepen: 'https://codepen.io/',
    
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // medium: 'https://medium.com/@',
    
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}